export const Rich = ({ text = "", accent = "text-orange-500" }) =>
  String(text)
    .split(/(\*[^*]+\*)/g)
    .map((part, i) =>
      part.startsWith("*") && part.endsWith("*") && part.length > 2 ? (
        <span key={i} className={accent}>{part.slice(1, -1)}</span>
      ) : (
        <span key={i}>{part}</span>
      )
    );

export default Rich;
